module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-ExtraBold.cac42811.ttf";